module.exports = __webpack_public_path__ + "static/media/scooter-blu.b48c136a.svg";